import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-app-update",
    templateUrl: "./app-update.component.html",
    styleUrls: ["./app-update.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class AppUpdateComponent implements OnInit {
  constructor(private matDialogRef: MatDialogRef<AppUpdateComponent>,
    public translate: TranslateService,
    private authService: AuthService) {
    this.authService?.selectedlanguage$?.subscribe((l) => {
      if (l) {
        translate.use(l ? l : "en");
      }
    }, err => { return (err) });
  }

  ngOnInit() { }

  updateMe() {
    this.matDialogRef.close(true);
  }
}
